// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"f0396456","577":"79d52893","585":"5c691d69","641":"de24855b","787":"002bde83","790":"898f03d3","987":"94098d69"}[chunkId] + ".chunk.js";
};